/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { ZodType } from 'zod';
import { AxiosResponse } from 'axios';

export function validateResponse<T>(
  schema: ZodType<T>,
  response: AxiosResponse,
): AxiosResponse {
  const result = schema.safeParse(response?.data);
  if (!result.success) {
    throw new Error(
      'Schema validation failed: ' + JSON.stringify(result.error.format()),
    );
  }
  return response;
}
